"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UnavailablePlanButton = _styledComponents.default.div.withConfig({
  displayName: "UnavailablePlanButton",
  componentId: "ruxqzy-0"
})(["width:100%;height:92px;background-color:", ";font-size:14px;", ""], _colors.GYPSUM, _responsiveBreakpoints.default.phone(_templateObject()));

var _default = UnavailablePlanButton;
exports.default = _default;
module.exports = exports.default;